import { createApp } from 'vue'
import ElementPlus from 'element-plus'
// development引入 production注释
import 'element-plus/dist/index.css'
import 'swiper/swiper-bundle.css'
import App from './App.vue'
import router from './router'
import store from './store'
import '@layui/layui-vue/lib/index.css'

createApp(App).use(store).use(router).use(ElementPlus).mount('#app')
